function Contact() {
  const universalEmail = "Worshippersuniteza@gmail.com";

  return (
    <section
      id="contact"
      style={{
        padding: "100px 20px",
        background: "#f2f2f2",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      {/* TITLE ONLY (no card wrapper) */}
      <h2 style={{ fontSize: "28px", marginBottom: "10px" }}>
        CONTACT US
      </h2>

      <p style={{ marginBottom: "40px", color: "#444", textAlign: "center" }}>
        For all enquiries: <br />
        <strong>{universalEmail}</strong>
      </p>

      {/* TWO CARDS */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          flexWrap: "wrap",
          maxWidth: "900px",
          width: "100%"
        }}
      >
        {/* Miranda Card */}
        <div
          style={{
            flex: "1",
            minWidth: "260px",
            borderRadius: "14px",
            padding: "25px",
            textAlign: "center",
            background: "#fff",
            boxShadow: "0 10px 25px rgba(0,0,0,0.10)"
          }}
        >
          <h3 style={{ margin: "0", fontSize: "20px" }}>
            Miranda Legodi
          </h3>

          <p style={{ margin: "5px 0", color: "#666" }}>
            Administrator
          </p>

          <div style={{ marginTop: "10px" }}>
            <span>+27 71 280 9164</span>
          </div>
        </div>

        {/* Omolemo Card */}
        <div
          style={{
            flex: "1",
            minWidth: "260px",
            borderRadius: "14px",
            padding: "25px",
            textAlign: "center",
            background: "#fff",
            boxShadow: "0 10px 25px rgba(0,0,0,0.10)"
          }}
        >
          <h3 style={{ margin: "0", fontSize: "20px" }}>
            Omolemo Morethe
          </h3>

          <p style={{ margin: "5px 0", color: "#666" }}>
            Administrator
          </p>

          <div style={{ marginTop: "10px" }}>
            <span>+27 71 578 7489</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;